document.addEventListener("DOMContentLoaded", function() {
    if (!!document.querySelector("#atc-bundle-v2") === true){
        var atcBtn = document.querySelector("#atc-bundle-v2");
    } else if (!!document.querySelector("#productMainSubmit") === true){
        var atcBtn = document.querySelector("#productMainSubmit");
    }

    if (atcBtn){

        window.addEventListener('scroll', function() {
            var btnPosition = atcBtn.getBoundingClientRect().top;
            if (btnPosition < 0) {
                document.querySelector(".sticky-atc").style.cssText = "bottom: 0px;";
            } else {
                document.querySelector(".sticky-atc").style.cssText = "bottom: -200px;";
            }
        });

        document.querySelector(".sticky-atc .button-sticky-atc").onclick = function() {
            atcBtn.scrollIntoView({ 
                behavior: 'smooth',
                block: 'center'
            });
            atcBtn.click();
        };

        if (!!document.querySelector('.bundle-products__list-product.active .compare-price') === true){
            if (!!document.querySelector('.bundle-products__list-product-2>span:not(.economisez):only-child') === true){
                document.querySelector(".sticky-atc .sticky-atc-title").textContent = document.querySelector(".bundle-products__list-product.active .bundle-products__list-product-2 span").textContent;
            } else {
                document.querySelector(".sticky-atc .sticky-atc-title").textContent = document.querySelector(".bundle-products__list-product.active .bundle-products__list-product-title>span").textContent;
            }
            document.querySelector(".sticky-atc .sticky-atc-price").textContent = document.querySelector('.bundle-products__list-product.active .compare-price').textContent;

            var bundleProducts = document.querySelectorAll('.bundle-products .bundle-products__list .bundle-products__list-product');
            for (var i = 0; i < bundleProducts.length; i++) {
                bundleProducts[i].addEventListener('click', function(event) {
                    if (!!document.querySelector('.bundle-products__list-product-2>span:not(.economisez):only-child') === true){
                        document.querySelector(".sticky-atc .sticky-atc-title").textContent = event.currentTarget.querySelector(".bundle-products__list-product-2 span").textContent;
                    } else {
                        document.querySelector(".sticky-atc .sticky-atc-title").textContent = event.currentTarget.querySelector(".bundle-products__list-product-title>span").textContent;
                    }
                    document.querySelector(".sticky-atc .sticky-atc-price").textContent = event.currentTarget.querySelector('.compare-price').textContent;
                });
            }

        } else {
            document.querySelector(".sticky-atc .sticky-atc-price").textContent = document.querySelector("#productMainSubmit .price.price--on-sale .price-item--sale").textContent;
        }
    }
});